<div class="section">
  <div class="heading-primary">{{ $t('shopping.basket.checkout.payment_method') }}</div>
  <ul class="payment-options" v-if="adyenInstance && cart">
    <li v-for="paymentMethod in availablePaymentMethods" :key="paymentMethod.service_type" :class="{active: activePaymentMethod === paymentMethod.service_type}">
      <div
        tabindex="0"
        class="payment-option"
        @click="handlePaymentMethodChange(paymentMethod)"
        @keydown.enter.prevent="handlePaymentMethodChange(paymentMethod)"
        @keydown.space.prevent="handlePaymentMethodChange(paymentMethod)"
      >
        <div class="tick">
          <span class="iconfont-check" v-if="activePaymentMethod === paymentMethod.service_type"></span>
        </div>
        <div class="description">
          <img :src="paymentMethod.icon" class="icon" alt="" />
          <span>{{ paymentMethod.name }}</span>
        </div>
      </div>
      <Walley v-if="activePaymentMethod === paymentMethod.service_type && getActivePaymentType(paymentMethod) === 'walley'" />
      <Klarna v-if="activePaymentMethod === paymentMethod.service_type && getActivePaymentType(paymentMethod) === 'klarna'" />
      <Trustly v-if="activePaymentMethod === paymentMethod.service_type && getActivePaymentType(paymentMethod) === 'trustly'" />
      <PayPal v-if="activePaymentMethod === paymentMethod.service_type && getActivePaymentType(paymentMethod) === 'paypal'" />
      <AdyenCard v-if="activePaymentMethod === paymentMethod.service_type && getActivePaymentType(paymentMethod) === 'scheme'" />
      <ApplePay v-if="activePaymentMethod === paymentMethod.service_type && getActivePaymentType(paymentMethod) === 'applepay'" />
      <GooglePay v-if="activePaymentMethod === paymentMethod.service_type && getActivePaymentType(paymentMethod) === 'googlepay'" />
      <EPS v-if="activePaymentMethod === paymentMethod.service_type && getActivePaymentType(paymentMethod) === 'eps'" :banks="paymentMethod.issuers" />
      <AmazonPay v-if="activePaymentMethod === paymentMethod.service_type && getActivePaymentType(paymentMethod) === 'amazon_pay_v2' && amazonPayConfig" :isButtonHidden="true" />
      <OnlineBanking v-if="activePaymentMethod === paymentMethod.service_type && getActivePaymentType(paymentMethod).startsWith('onlineBanking')" :banks="paymentMethod.issuers" />
    </li>
  </ul>
</div>
